import React from 'react'
import styles from './styles.module.scss'

const SecureText: React.FC = () => {
    return <span className={styles.secureText}>Private & secure</span>
}

export default SecureText
